import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import 'tom-select/dist/css/tom-select.default.css'

// https://tom-select.js.org/docs/
export default class extends Controller {
  static targets = ['select']

  connect() {
    this.select = this.hasSelectTarget ? this.selectTarget : this.element
    // A <dialog> renders in the browser's top layer; a dropdown appended
    // to document.body is a normal node and would render behind it
    // regardless of z-index. Always append to the nearest dialog (or
    // body if none) and position it ourselves — tom-select's own
    // positionDropdown() only computes fixed coordinates when
    // dropdownParent is the exact string 'body', not an element, so
    // passing an element (either way) always needs our own math.
    const target = this.select.closest('dialog') || document.body
    this.ts = new TomSelect(this.select, {
      // https://tom-select.js.org/plugins/
      plugins: ['remove_button'],
      create: false,
      maxOptions: null,
      hidePlaceholder: true,
      dropdownParent: target,
      onDropdownOpen: (dropdown) => this.#positionDropdown(dropdown),
    })
  }

  #positionDropdown(dropdown) {
    const rect = this.ts.control.getBoundingClientRect()
    dropdown.style.position = 'fixed'
    dropdown.style.top = `${rect.bottom + 2}px`
    dropdown.style.left = `${rect.left}px`
    dropdown.style.width = `${rect.width}px`
    dropdown.style.margin = '0'
  }

  selectAll(event) {
    event.preventDefault()
    const values = Array.from(this.select.options).map((option) => option.value)
    this.ts.setValue(values)
  }

  clearAll(event) {
    event.preventDefault()
    this.ts.clear()
  }

  disconnect() {
    this.ts?.destroy()
  }
}
